var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.location))]),(!_vm.isLoading)?_c('div',[(_vm.filteredTable.length > 0)?_c('div',{staticStyle:{"width":"425px"}},[_c('BasicTableComponent',{attrs:{"list":_vm.subtotals,"totals":_vm.totals,"tableClass":"table2excel","tableID":`${_vm.location}_Cashiers`,"showColumns":['cashier' , 'Hours', 'RoundedHours'],"columnOrder":['cashier', 'Hours', 'RoundedHours'],"formatters":{
          'day' : ['d', 'ddd MM/DD/YY'], 
          'StartDateTime' : ['d', 'h:mm a'], 
          'EndDateTime' : ['d', 'h:mm a'], 
          'Start' : ['d', 'h:mm a'], 
          'End' : ['d', 'h:mm a'], 
          'Hours' : ['n', '0,0.00'], 
          'RoundedHours' : ['n', '0,0.00'], 
        },"titles":{
          'StartDateTime' : 'Shift Start', 
          'EndDateTime' : 'Shift End', 
          'RoundedHours' : 'Rounded Hours',
        }}}),_c('BasicTableComponent',{attrs:{"list":_vm.filteredTable,"totals":_vm.totals,"tableClass":"table2excel","tableID":`${_vm.location}_Days`,"showColumns":['day', 'StartDateTime', 'EndDateTime', 'cashier', 'Start', 'End', 'Hours', 'RoundedHours'],"columnOrder":['day', 'StartDateTime', 'EndDateTime', 'cashier', 'Start', 'End', 'Hours' , 'RoundedHours'],"formatters":{
          'day' : ['d', 'ddd MM/DD/YY'], 
          'StartDateTime' : ['d', 'h:mm a'], 
          'EndDateTime' : ['d', 'h:mm a'], 
          'Start' : ['d', 'h:mm a'], 
          'End' : ['d', 'h:mm a'], 
          'Hours' : ['n', '0,0.00'], 
          'RoundedHours' : ['n', '0,0.00'], 
        },"titles":{
          'StartDateTime' : 'Shift Start', 
          'EndDateTime' : 'Shift End', 
          'RoundedHours' : 'Rounded Hours', 
        }}})],1):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }